//
//
//
//
//
//
//
//
//
//
//
import TemplateReturn from './TemplateReturn.vue';
export default {
  name: 'ProductNotShipped',
  components: {
    TemplateReturn
  },
  props: {
    title: {
      type: String,
      required: true
    },
    orderList: {
      type: Array,
      required: true
    },
    preSelectedBl: {
      type: String,
      default: ''
    },
    pendingRequest: {
      type: Boolean,
      required: true
    }
  }
};